
import React from 'react'
import Backdrop from '@material-ui/core/Backdrop'
import { makeStyles } from '@material-ui/core/styles'
import CircularIndeterminate from '../circularLoader'

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 9999999,
    color: '#fff'
  }
}))

const LoaderComponent = ({ isOpen = true }) => {
  const classes = useStyles()
  return (
    <Backdrop className={classes.backdrop} open={isOpen}>
      <CircularIndeterminate color='inherit' />
    </Backdrop>
  )
}

export default LoaderComponent
